import { neverHere } from "../tsHelpers";

export const asArray = () => [
  EnquiryStatus.New,
  EnquiryStatus.Engaging,
  EnquiryStatus.ItinerarySent,
  EnquiryStatus.ItineraryViewed,
  EnquiryStatus.Booked,
  EnquiryStatus.FullyPaid,
  EnquiryStatus.InProgress,
  EnquiryStatus.Complete,
  EnquiryStatus.Cancelled,
  EnquiryStatus.LowIntent,
  EnquiryStatus.Triage,
];

export const toFriendlyName = (status: EnquiryStatus) => {
  switch (status) {
    case EnquiryStatus.LowIntent:
      return "Low intent";
    case EnquiryStatus.Triage:
      return "Triage";
    case EnquiryStatus.New:
      return "New";
    case EnquiryStatus.Engaging:
      return "Engaging";
    case EnquiryStatus.ItinerarySent:
      return "Itinerary sent";
    case EnquiryStatus.ItineraryViewed:
      return "Itinerary viewed";
    case EnquiryStatus.Booked:
      return "Booked";
    case EnquiryStatus.FullyPaid:
      return "Fully paid";
    case EnquiryStatus.InProgress:
      return "Travelling";
    case EnquiryStatus.Complete:
      return "Complete";
    case EnquiryStatus.Cancelled:
      return "Cancelled";
    default:
      neverHere(status);
  }
};

export const toSlug = (status: EnquiryStatus) => {
  switch (status) {
    case EnquiryStatus.LowIntent:
      return "low_intent";
    case EnquiryStatus.Triage:
      return "triage";
    case EnquiryStatus.New:
      return "new";
    case EnquiryStatus.Engaging:
      return "engaging";
    case EnquiryStatus.ItinerarySent:
      return "itinerary_sent";
    case EnquiryStatus.ItineraryViewed:
      return "itinerary_viewed";
    case EnquiryStatus.Booked:
      return "booked";
    case EnquiryStatus.FullyPaid:
      return "fully_paid";
    case EnquiryStatus.InProgress:
      return "travelling";
    case EnquiryStatus.Complete:
      return "complete";
    case EnquiryStatus.Cancelled:
      return "cancelled";
    default:
      neverHere(status);
  }
};
